var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.5 8.25C6.08579 8.25 5.75 8.58579 5.75 9C5.75 10.5188 6.98122 11.75 8.5 11.75C10.0188 11.75 11.25 10.5188 11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9C9.75 9.69036 9.19036 10.25 8.5 10.25C7.80964 10.25 7.25 9.69036 7.25 9C7.25 8.58579 6.91421 8.25 6.5 8.25ZM13.5 8.25C13.0858 8.25 12.75 8.58579 12.75 9C12.75 10.5188 13.9812 11.75 15.5 11.75C17.0188 11.75 18.25 10.5188 18.25 9C18.25 8.58579 17.9142 8.25 17.5 8.25C17.0858 8.25 16.75 8.58579 16.75 9C16.75 9.69036 16.1904 10.25 15.5 10.25C14.8096 10.25 14.25 9.69036 14.25 9C14.25 8.58579 13.9142 8.25 13.5 8.25ZM9.5 15C8.67157 15 8 15.6716 8 16.5C8 17.3284 8.67157 18 9.5 18H14.5C15.3284 18 16 17.3284 16 16.5C16 15.6716 15.3284 15 14.5 15H9.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad1);
export default __webpack_public_path__ + "static/media/sad-1.e83b4112ade21abf21a767af679b0edb.svg";
export { ForwardRef as ReactComponent };